import sidebarLinkPlugin from './sidebarLinkPlugin ';

const leftMenuPlugin: any = {
  Renderer: ({ children }: any) => (
    <div
      className="emergency-box1"
      style={{
        width: 250,
        margin: '10px auto',
        padding: 10,
      }}
    >
      {children}
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: sidebarLinkPlugin,
        },
      ],
    ];
  },

  id: 'leftMenuPlugin',
  title: 'Sidebar Link container',
  description: `Plugin for the Manual's left menu`,
  version: 1,
  // controls: {
  //   type: 'autoform',
  //   schema: {
  //     required: ['backgroundColor'],
  //     properties: {
  //       backgroundColor: { type: 'string' },
  //     },
  //   },
  // },
};

export default leftMenuPlugin;
